<template>
  <div id="row-number">
    <!-- 考场排号 -->
    <div class="content" v-loading="loading">
      <div class="goback" @click="goback">
        <i class="el-icon-d-arrow-left"></i>返回
      </div>

      <div class="tip">
        <div class="li">
          <div class="ti">考场号:</div>
          <div class="va">
            <el-dropdown>
              <span>
                {{ data[index].examRoom }}
                <i class="el-icon-arrow-down el-icon--right"></i
              ></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item, i) in data" :key="i">
                  <span @click="index = i">{{ item.examRoom }}</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="li">
          <div class="ti">参考部门:</div>
          <div class="va">{{ department }}</div>
        </div>
        <div class="li">
          <div class="ti">参考人数:</div>
          <div class="va">{{ data[index].userExamPlan.length }}人</div>
        </div>
        <div class="li"></div>
      </div>
      <div class="ph">
        <div
          class="item"
          v-for="(item, ii) in data[index].userExamPlan"
          :key="ii"
          v-dragging="{
            list: data[index].userExamPlan,
            item: item,
            group: 'userId',
          }"
        >
          <div class="th" @click="changeUser(ii)">移除</div>
          <div class="icon">
            <img :src="item.icon" alt="" />
          </div>
          <div class="line">
            <div class="title">姓名:</div>
            <div class="value">{{ item.name }}</div>
          </div>
          <div class="line">
            <div class="title">座位号:</div>
            <div class="value">{{ ii + 1 }}</div>
          </div>
        </div>
        <div class="item div-flex-center" @click="addUser">
          <i class="el-icon-plus"></i>
          添加学员
        </div>
      </div>
      <div class="tip div-flex-center">
        <div class="add_but" @click="saveOrUpdateExam">
          <i class="el-icon-check"></i> 确定
        </div>
      </div>
    </div>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as examData from "./js/exam.js";
export default {
  data() {
    return {
      loading: true,
      id: "",
      examinationRoomNumber: "23号考场", // 考场号
      department: "市场一部", // 参考部门
      peopleNum: "50", // 参考人数

      data: [
        {
          examRoom: "", // 考场号
          userExamPlan: examData.getAutomaticNumbering(),
        },
      ],
      examRoom: [],
      userId: [],
      index: 0,

      dialogData: {
        flag: false,
        title: "选择学员",
        width: "35%",
        tempData: {},
        dialogData: [
          { type: "select", value: "", title: "选择学员", options: [] },
        ],
        buttonList: [
          { text: "确定", active: "makesure" },
          { text: "取消", active: "cancel" },
        ],
      },
    };
  },
  methods: {
    /**
     * 添加考试安排
     * 当初次进行排号操作,调用该接口
     * 或重新自行排号,调用该接口
     */
    async generateExamPlan() {
      try {
        let list = JSON.parse(sessionStorage.getItem("userList"));
        let userList = [];
        list.forEach((element) => {
          if (element.flag && element.userId != null) {
            userList.push(element.userId);
          }
        });
        let requestData = {
          id: this.id, // 考试ID
          examRoom: this.examRoom, // 考场
          userList: userList, // 所有满足条件的userId  从上一个界面获取
        };
        let resultData = await this.$request({
          url: "/examPlan/generateExamPlan",
          method: "post",
          data: requestData,
        });
        this.data = resultData;
        this.loading = false;
      } catch (error) {
        this.$router.back();
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 查看考试安排
     * 非初次排号,进入该界面获取其已有的考试安排计划
     */
    async showExamPlan() {
      try {
        let requestData = {
          id: this.id, // 考试ID
        };
        let resultData = await this.$request({
          url: "/examPlan/showExamPlan",
          method: "post",
          data: requestData,
        });
        this.data = resultData;
        this.loading = false;
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    /**
     * 保存考试安排
     */
    async saveOrUpdateExam() {
      try {
        this.data.forEach((element) => {
          element.userExamPlan.forEach((ele, index) => {
            ele.seat = index + 1;
          });
        });
        let requestData = {
          id: this.id,
          details: this.data,
        };
        let resultData = await this.$request({
          url: "/examPlan/saveExamPlan",
          method: "post",
          data: requestData,
        });
        this.$message.success("保存成功!");
        this.goback();
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 替换具体排考学员
     */
    async changeUser(index) {
      try {
        this.$confirm("确定将该学员移除本场考试吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.data[this.index].userExamPlan.splice(index, 1);
            this.$message({
              type: "success",
              message: "操作成功!",
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    /**
     * 添加学员
     */
    async addUser() {
      let resultData = await this.$request({
        url: "/user/getUserDropList",
        method: "post",
        data: {},
      });
      let option = [];
      resultData.forEach((element) => {
        let dd = {
          label: element.name,
          value: element.id,
        };
        option.push(dd);
      });
      this.dialogData.dialogData[0].options = option;
      this.dialogData.dialogData[0].value = "";
      this.dialogData.flag = true;
    },
    async dialogOper(active) {
      try {
        switch (active) {
          case "makesure":
            // 确定添加学员
            this.loading = true;
            let userId = this.dialogData.dialogData[0].value;
            if (userId == "") {
              throw "请选择要添加的学员!";
            }
            this.data.forEach((element) => {
              element.userExamPlan.forEach((ele) => {
                if (element.userId == userId) {
                  throw "该学员已存在于本场考试,无需重新添加!";
                }
              });
            });
            let requestData = { id: userId };
            let resultData = await this.$request({
              url: "/user/getUserDetails",
              method: "post",
              data: requestData,
            });
            let dd = {
              icon: resultData.icon,
              id: "",
              name: resultData.name,
              seat: 0,
              userId: resultData.id,
            };
            this.data[this.index].userExamPlan.push(
              JSON.parse(JSON.stringify(dd))
            );
            this.dialogData.flag = false;
            this.loading = false;
            break;
          case "cancel":
            // 关闭弹出框
            this.colseDialog();
            break;

          default:
            break;
        }
      } catch (error) {
        this.loading = false;
        this.$message.error(error);
      }
    },
    /**
     * 返回上一页
     */
    goback() {
      this.$router.back();
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  async mounted() {
    this.id = this.$route.query.id;
    let flag = this.$route.query.flag;
    if (flag == "1") {
      await this.showExamPlan();
    } else {
      this.examRoom = JSON.parse(sessionStorage.getItem("examRoom"));
      await this.generateExamPlan();
    }
    this.$dragging.$on("dragged", (value) => {
      //因为我这在排序的时候不需要做处理，所以空着就行
      // debugger;
    });
  },
};
</script>

<style lang="less" scoped>
#row-number {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px 15px;
  box-sizing: border-box;
  > .content {
    width: 100%;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    > .tip {
      width: 100%;
      height: 40px;
      display: flex;
      justify-content: space-between;
      padding-left: 20px;
      box-sizing: border-box;
      margin-top: 20px;
      > .li {
        width: 0;
        flex: 1;
        height: 100%;
        display: flex;
        > .ti {
          font-weight: bold;
          margin-left: 10px;
          margin-right: 10px;
        }
      }
    }
    > .ph {
      width: 100%;
      height: auto;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: space-around;
      padding-left: 20px;
      box-sizing: border-box;
      margin-top: 20px;
      transition: 0.3s;
      > .item {
        width: 220px;
        height: 220px;
        background-color: #f2f2f2;
        margin-bottom: 10px;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        padding: 5px;
        box-sizing: border-box;
        position: relative;
        align-items: center;
        padding-top: 10px;
        margin-left: 5px;
        > .th {
          position: absolute;
          top: 5px;
          right: 5px;
          color: #1399e7;
          cursor: pointer;
        }
        > .icon {
          width: 120px;
          height: 120px;
          background-color: #cccccc9d;
          padding: 10px;
          box-sizing: border-box;
          > img {
            width: 100px;
            height: 100px;
          }
        }
        > .line {
          width: 100%;
          height: 30px;
          line-height: 30px;
          text-align: center;
          display: flex;
          align-items: center;
          > .title {
            width: 80px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            margin-right: 5px;
            font-weight: bold;
          }
          > .value {
            width: 0;
            flex: 1;
            display: flex;
            align-items: center;
          }
        }
        > i {
          font-size: 50px;
          color: #686868;
        }
      }
    }
  }
}
</style>